import React from 'react'
import { InputWrapper, InputWrapperDirection } from '.'
import { classNameBuilder } from '@/helpers'
import { UncontrolledFormElement } from '@/types/themeType'

interface TextInputProps extends UncontrolledFormElement {
  direction?: InputWrapperDirection
  className?: { input?: string; wrapper?: string }
}

export const TextInput: React.FC<TextInputProps> = React.forwardRef(
  (
    {
      id,
      testId,
      label,
      direction,
      disabled,
      required,
      error,
      className,
      ...inputProps
    },
    ref
  ) => {
    return (
      <InputWrapper
        label={label}
        labelFor={id}
        className={className?.wrapper}
        error={error}
        direction={direction}
        required={required}
        disabled={disabled}
      >
        <input
          id={id}
          type="text"
          {...{ 'data-test-id': testId }}
          {...inputProps}
          disabled={disabled}
          required={required}
          className={classNameBuilder(
            'rounded-2 inline h-11 rounded-lg border px-3 text-gray-400 placeholder-gray-300 outline-none transition duration-300',
            !error && !disabled ? defaultClasses : '',
            !disabled && error ? errorClasses : '',
            disabled ? disabledClasses : '',
            className?.input
          )}
          ref={ref}
        />
      </InputWrapper>
    )
  }
)

const defaultClasses =
  'text-gray-700 border-gray-300 focus:border-electric-indigo-500 focus-visible:ring-2 focus:ring-electric-indigo-50'
const errorClasses =
  'text-gray-700 border-red-600 focus-visible:ring-2 focus:ring-red-200'
const disabledClasses =
  'text-gray-600 bg-[#101828]/5 cursor-not-allowed border-gray-200'

TextInput.displayName = 'TextInput'
export default TextInput
